export default "__VITE_ASSET__BicFBcea__"